import './MainPageSub04_1.scss';
import fig_search from '../images/home/fig_search.png'; 
import React, { useEffect } from 'react';
import VideoPlayer from '../video/VideoPlayer';

const MainPageSub04_1 = () => {


    const handlePlay = () => {
        // 조회수 업데이트 로직
        // console.log("비디오 재생 시작");
        // setViews(views + 1); // 조회수 1 증가
        // 여기서 백엔드 API를 호출하여 실제 조회수를 업데이트할 수 있음
      };
     
    //====================================================================
    return (
        <div className="MainPageSub04_1">
            <section className='sec-main'>

                <section className='sec-sub1'>
                    <article className='art-main'>
                        <p className="heading-3 title2">학습과 공부는 분명히 다르다!</p>
                        <section className="description2">
                            <p>
                                학습과 공부의 차이를 아래 영상을 통해 자세히 접해 주시길 바랍니다. <br/>
                                그 차이가 이해되어야 공부력은 향상 될 수 있습니다
                            </p>
                        </section>
                    </article>
                </section>

                <section className="sec-video">
                            <article className='art-video'>                            
                                <p>학습과 공부</p>
                                <VideoPlayer 
                                    url={'https://youtu.be/O4OfzIINTpY'} 
                                    onPlay={handlePlay} 
                                />

                            </article>

                            <article className='art-video'>
                                <p>초등 공부력</p>
                                <VideoPlayer 
                                    url={'https://youtu.be/6-via7iLit0'} 
                                    onPlay={handlePlay} 
                                />

                            </article>

                            <article className='art-video'>
                                <p>중등 공부력</p>
                                <VideoPlayer 
                                    url={'https://youtu.be/fj_Ur6fQQBE'} 
                                    onPlay={handlePlay} 
                                />

                            </article>

                            <article className='art-video'>
                                <p>고등 공부력</p>
                                <VideoPlayer 
                                    url={'https://youtu.be/A-flpdxFBoY'} 
                                    onPlay={handlePlay} 
                                />

                            </article>
                </section>



            </section>
        </div>
    );
};

export default MainPageSub04_1;
